import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { v4 as uuid4 } from "uuid";
import { environment } from '../../../../environments/environment';
import { OtherKpModel } from '../models/other-kp-model';
import { BehaviorSubject, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistributorOtherKp } from '../models/distributor-other-kp';
import { Nomenclature } from '../models/nomenclature';
import { LoggingService } from '../../../services/logging.service';


const API_SERVER = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.other-kp.component.other-kp-detail.service";


@Injectable()
export class OtherKpDetailService {
  isNew: boolean = false
  viewKpNumber: string = "Новый";
  newCustomerInn: string = "";
  newCustomerName: string = "";
  noNeedUpdateNewCustomerName: boolean = false;

  isHaveErrors: boolean = false

  /** спиннер в модальных окошках крутится до окончания загрузки списков (КАМ, заказчики, ..) */
  isOpeningKp: boolean = false;

  /** Режим открытия из карточки аукциона (замена конкурентов) */
  auctionMode: boolean = false;
  auctionCode: string = null;

  private kpSavedSubject$ = new Subject<void>();
  kpSaved$ = this.kpSavedSubject$.asObservable();

  private messageDistributerAuction = new BehaviorSubject<DistributorOtherKp>(new DistributorOtherKp());
  private currentStateDistributerAuction = new DistributorOtherKp();

  currentOtherKp = new OtherKpModel()
  otherKp = new BehaviorSubject<OtherKpModel>(new OtherKpModel())
  otherKp$ = this.otherKp.asObservable();

  private reload$ = new Subject<void>();
  reloadTable$ = this.reload$.asObservable();

  private triggerSave$ = new Subject<void>();
  triggerSaveObserver$ = this.triggerSave$.asObservable();

  private triggerUpdateLists$ = new Subject<void>();
  triggerUpdateListsObserver$ = this.triggerUpdateLists$.asObservable();

  private triggerReloadTemplate$ = new Subject<void>();
  triggerReloadTemplateObserver$ = this.triggerReloadTemplate$.asObservable();

  preSelectedNomenclature: Array<Nomenclature> = []

  private preSelectedNomenclaturesUpdate$ = new Subject<void>();
  preSelectedNomenclatures$ = this.preSelectedNomenclaturesUpdate$.asObservable();

  private preSelectedCustomersUpdate$ = new Subject<void>();
  preSelectedCustomers$ = this.preSelectedCustomersUpdate$.asObservable();

  constructor(
    private client: HttpClient,
    private loggingService: LoggingService
  ) { }

  changeNomenclature(nomenclatureList: Array<number>) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.changeNomenclature';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Changing nomenclature');

      const list = this.currentOtherKp.nomenclatureList || [];


      // 1. Оставляем только те, что есть в новом списке
      this.currentOtherKp.nomenclatureList = list.filter(
        el => el && nomenclatureList.includes(el.goodId)
      );
      // 2. Добавляем новые, которых ещё нет
      const existingIds = this.currentOtherKp.nomenclatureList.map(el => el.goodId);
      for (const id of nomenclatureList) {
        if (id != null && !existingIds.includes(id)) {
          this.currentOtherKp.nomenclatureList.push(
            Object.assign(new Nomenclature(), { goodId: id }));
        }
      }

      this.updateTempData()

      this.loggingService.logFinish(xid, qualName, null, 'Nomenclature changed');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Failed to change nomenclature');
      throw error;
    }
  }

  changeCustomer(customerName: string, customerId: string) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.changeCustomer';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Changing customer');

      this.currentOtherKp.customerName = customerName
      this.currentOtherKp.customerId = customerId
      this.triggerReloadTemplate()

      this.loggingService.logFinish(xid, qualName, null, 'Customer changed');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Failed to change customer');
      throw error;
    }
  }

  changeDistributor(distributorName: string, distributorId: string) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.changeDistributor';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Changing distributor');

      this.currentOtherKp.distributorName = distributorName
      this.currentOtherKp.distributorId = distributorId
      this.triggerReloadTemplate()

      this.loggingService.logFinish(xid, qualName, null, 'Distributor changed');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Failed to change distributor');
      throw error;
    }
  }

  updateTempData(spinner: NgxSpinnerService = null) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.updateTempData';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Updating temp data');

      this.client.put<OtherKpModel>(`${API_SERVER}/otherKp/putTemp`, this.currentOtherKp).subscribe(result => {
        this.currentOtherKp = result
        this.noNeedUpdateNewCustomerName = true
        this.otherKp.next(this.currentOtherKp)
        if (spinner != null) {
          spinner.hide();
        }
        this.loggingService.logFinish(xid, qualName, null, 'Temp data updated');
      }, error => {
        this.loggingService.logError(xid, qualName, error, null, 'Failed to update temp data');
      });
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Update temp data method failed');
      throw error;
    }
  }


  public putOtherKp(otherKp: OtherKpModel) {
    return this.client.put<OtherKpModel>(`${API_SERVER}/otherKp/putDetail`, otherKp);
  }

  public getNew(spinner: NgxSpinnerService = null) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.getNew';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Getting new other KP');

      this.isNew = true
      this.viewKpNumber = "Новый"
      this.client.get<OtherKpModel>(`${API_SERVER}/otherKp/getOtherKpId`).subscribe(result => {
        this.currentOtherKp = result
        this.currentOtherKp.typeId = 0
        this.currentOtherKp.statusKP = "Новый"
        this.otherKp.next(this.currentOtherKp)

        this.loggingService.logFinish(xid, qualName, null, 'New other KP created');
      }, error => {
        this.loggingService.logError(xid, qualName, error, null, 'Failed to get new other KP');
      });
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Get new method failed');
      throw error;
    }
  }

  public openOtherKp(otherKp: OtherKpModel, spinner: NgxSpinnerService = null) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.openOtherKp';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Opening other KP');

      spinner.show();
      this.viewKpNumber = this.currentOtherKp.id
      this.isNew = false
      this.client.put<OtherKpModel>(`${API_SERVER}/otherKp/getOtherKpData`, otherKp).subscribe(result => {
        this.currentOtherKp = result
        this.viewKpNumber = this.currentOtherKp.id
        this.isNew = false
        this.otherKp.next(this.currentOtherKp)
        // Спиннер скрывается в модалке после загрузки списков (КАМ и др.) в updateLocalLists()
        this.loggingService.logFinish(xid, qualName, null, 'Other KP opened');
      }, error => {
        this.loggingService.logError(xid, qualName, error, null, 'Failed to open other KP');
      });
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Open other KP method failed');
      throw error;
    }
  }

  triggerReload() {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.triggerReload';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Triggering reload');

      this.reload$.next();

      this.loggingService.logFinish(xid, qualName, null, 'Reload triggered');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Trigger reload failed');
      throw error;
    }
  }

  triggerReloadTemplate(): void {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.triggerReloadTemplate';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Triggering template reload');

      this.triggerReloadTemplate$.next();

      this.loggingService.logFinish(xid, qualName, null, 'Template reload triggered');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Trigger template reload failed');
      throw error;
    }
  }

  triggerSave(): Promise<boolean> {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.triggerSave';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Triggering save');

      this.triggerSave$.next();
      return new Promise(resolve => setTimeout(() => {
        this.loggingService.logFinish(xid, qualName, null, 'Save triggered');
        resolve(this.isHaveErrors)
      }, 2000))
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Trigger save failed');
      throw error;
    }
  }

  triggerUpdateLists(): void {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.triggerUpdateLists';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Triggering list update');

      this.triggerUpdateLists$.next();

      this.loggingService.logFinish(xid, qualName, null, 'List update triggered');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Trigger list update failed');
      throw error;
    }
  }

  triggerReloadNomenclature(): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.OtherKpDetailService.triggerReloadNomenclature`;
    const inputParams = {};
    const description = "[Notifier] Триггер перезагрузки списка выбранной номенклатуры";

    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);

      this.preSelectedNomenclature = this.currentOtherKp.nomenclatureList
      this.preSelectedNomenclaturesUpdate$.next()

      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }


  public openForAuction(auctionCode: string, spinner: NgxSpinnerService = null) {
    const xid = this.loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.OtherKpDetailService.openForAuction`;
    const inputParams = { auctionCode };
    const description = "Создание другого КП по кнопке 'Замена конкурентов' из аукциона";

    this.loggingService.logStart(xid, qualName, inputParams, description);

    try {
      this.auctionMode = true;
      this.auctionCode = auctionCode;
      this.isOpeningKp = true;

      if (spinner) spinner.show();
      this.loggingService.logStart(xid, `${qualName}.getOtherKpId`, inputParams, `${description}: получение нового ID КП`);

      this.client.get<OtherKpModel>(`${API_SERVER}/otherKp/getOtherKpId`).subscribe(
        result => {
          this.currentOtherKp = result;

          // Логируем успешное создание/получение нового ID КП
          this.loggingService.logFinish(xid, `${qualName}.getOtherKpId`, inputParams, `${description}: получение новый ID КП`);

          const params = new HttpParams()
            .set('auctionCode', auctionCode)
            .set('otherKpId', String(this.currentOtherKp?.id ?? 0));

          this.client.get<OtherKpModel>(
            `${API_SERVER}/otherKp/getByAuction`,
            { params }
          ).subscribe(
            result => {
              this.currentOtherKp = result;
              this.viewKpNumber = result.id ?? 'Новый';
              this.isNew = result.id == null;
              this.otherKp.next(this.currentOtherKp);

              this.loggingService.logFinish(xid, qualName, inputParams, description);
            },
            error => {
              if (spinner) spinner.hide();
              this.isOpeningKp = false;
              this.loggingService.logError(xid, qualName, error, inputParams, description);
            }
          );
        },
        error => {
          if (spinner) spinner.hide();
          this.isOpeningKp = false;
          this.loggingService.logError(xid, `${qualName}.getOtherKpId`, error, inputParams, `${description}: получение нового ID КП`);
        }
      );
    } catch (error) {
      if (spinner) spinner.hide();
      this.isOpeningKp = false;
      this.loggingService.logError(xid, qualName, error, inputParams, `${description}`);
      throw error;
    }
  }



  public applyKpToAuction(): void {
    const xid = this.loggingService.generateUUID();
    const qualName = `${MODULE_PATH}.OtherKpDetailService.applyKpToAuction`;

    try {
      this.loggingService.logStart(xid, qualName, null, 'Applying KP to auction');

      this.auctionMode = false;
      this.auctionCode = null;

      this.loggingService.logFinish(xid, qualName, null, 'KP applied to auction');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Failed to apply KP to auction');
      throw error;
    }
  }

  public notifyKpSaved(): void {
    this.kpSavedSubject$.next();
  }

  public resetAuctionMode(): void {
    this.auctionMode = false;
    this.auctionCode = null;
  }

  changeDistributerAuction(distribAuction: DistributorOtherKp) {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.OtherKpDetailService.changeDistributerAuction';

    try {
      this.loggingService.logStart(xid, qualName, null, 'Changing distributer auction');

      Object.keys(distribAuction).forEach(key => {
        if (distribAuction != null && distribAuction[key] != null) {
          this.currentStateDistributerAuction[key] = distribAuction[key];
        }
      });
      this.messageDistributerAuction.next(this.currentStateDistributerAuction);

      this.loggingService.logFinish(xid, qualName, null, 'Distributer auction changed');
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, null, 'Failed to change distributer auction');
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/services/other-kp-detail.service.ts